import { render, staticRenderFns } from "./StatusSelectorForDashboard.vue?vue&type=template&id=2315e0d6&scoped=true"
import script from "./StatusSelectorForDashboard.vue?vue&type=script&lang=js"
export * from "./StatusSelectorForDashboard.vue?vue&type=script&lang=js"
import style0 from "./StatusSelectorForDashboard.vue?vue&type=style&index=0&id=2315e0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2315e0d6",
  null
  
)

export default component.exports